var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.1425 1.5H5.8575C3.45092 1.5 1.5 3.45092 1.5 5.8575V12.1425C1.5 14.5491 3.45092 16.5 5.8575 16.5H12.1425C14.5491 16.5 16.5 14.5491 16.5 12.1425V5.8575C16.5 3.45092 14.5491 1.5 12.1425 1.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0572 9.00002L12.1797 6.87752C12.2582 6.81028 12.3219 6.72755 12.367 6.6345C12.412 6.54145 12.4373 6.4401 12.4413 6.33681C12.4452 6.23352 12.4278 6.13052 12.3901 6.03428C12.3524 5.93803 12.2952 5.85062 12.2221 5.77753C12.1491 5.70444 12.0616 5.64725 11.9654 5.60954C11.8692 5.57184 11.7662 5.55443 11.6629 5.55842C11.5596 5.56241 11.4582 5.58771 11.3652 5.63272C11.2721 5.67774 11.1894 5.74151 11.1222 5.82002L8.99966 7.94252L6.87716 5.82002C6.73368 5.69715 6.54912 5.63294 6.36037 5.64024C6.17161 5.64753 5.99256 5.72578 5.85898 5.85935C5.72541 5.99292 5.64716 6.17197 5.63987 6.36073C5.63258 6.54949 5.69679 6.73404 5.81966 6.87752L7.94216 9.00002L5.81966 11.1225C5.67997 11.263 5.60156 11.4531 5.60156 11.6513C5.60156 11.8494 5.67997 12.0395 5.81966 12.18C5.96018 12.3197 6.15027 12.3981 6.34841 12.3981C6.54655 12.3981 6.73664 12.3197 6.87716 12.18L8.99966 10.0575L11.1222 12.18C11.2627 12.3197 11.4528 12.3981 11.6509 12.3981C11.849 12.3981 12.0391 12.3197 12.1797 12.18C12.3193 12.0395 12.3978 11.8494 12.3978 11.6513C12.3978 11.4531 12.3193 11.263 12.1797 11.1225L10.0572 9.00002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossSquare);
export default __webpack_public_path__ + "static/media/cross-square.e01f2f2ac328d2cfc32210c7d8c90dd0.svg";
export { ForwardRef as ReactComponent };